import React from "react";
import "./Terms2.css"; 
import SeventhComponent from './SeventhComponent';
import LogoRealScore from './assets/RealScoreLogo.webp';


const PrivacyPolicy = () => {
    return (
        <div className="outer-priv">
            <div className="nav-term">
                    <img src={LogoRealScore} alt="Logo" height="40px" />
            </div>
            <div className="text-term">
                <h2>Privacy Policy</h2>
                <p>
                     

The website and LoanUnbox / RealScore mobile application (the “service”). This section contains the Privacy Policy (“Policy”) of the Website and should be read along with the Terms and Conditions of Use of the Website.

Each visitor (“You”) who visits the Website, accesses any of the pages and/or provides information on the Website to LoanUnbox (“LoanUnbox / RealScore” or “We” or “Our”) has agreed to the terms set out in this Policy.

This Policy describes how LoanUnbox may collect, use and share any information (“Information”) You provide, including Information collected by the LoanUnbox/ RealScore’ s server from your browser, when You visit this Website, receive our emails, or phone call, interact with advertisements we have on any third-party websites. Further, by registering yourself at the Website, you authorize LoanUnbox / RealScore to contact you in order to communicate details of the services You have consented to receive,provide details of programmers' and schemes, offering promotional offers running on the Website & offers offered by the associated third parties.

We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. In order to operate the Website and provide you with details on services, facilities and programmers that may be of interest to you, LoanUnbox may collect Information including but not limited to postal address, phone number, email address computer’s unique Internet Protocol address, credit and debit card numbers, bank and other account numbers, passwords, PIN code, home town, gender, age, website cookies and website usage data from You. We may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device (“Usage Data”).

We may receive and process information about your location. For example, with your consent, we may collect information about the specific location of your mobile device (for example, by using GPS or Bluetooth). We may also receive location information from you when you choose to share such information on our Services, including by associating your content with a location, or we may derive your approximate location from other information about you, including your IP address.

This Usage Data may include information such as your computer’s Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.

When you access the Service by or through a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.


Tracking & Cookies Data
We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.

Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.

You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.

Examples of Cookies we use:

Session Cookies. We use Session Cookies to operate our Service.

Preference Cookies. We use Preference Cookies to remember your preferences and various settings.

Security Cookies. We use Security Cookies for security purposes.

LoanUnbox collects only such personal information that we believe to be relevant and would be required to understand Your or your business’s financial requirements. All information collected shall be used by LoanUnbox for the sole purpose of providing You with the best possible customer products and services.

LoanUnbox shall not sell, rent, or otherwise disburse information provided by You to a third party unless the same is required by LoanUnbox to provide services to You, or to enable a transaction, credit reporting, required pursuant to applicable banking norms, law or pursuant to the terms and conditions applicable to such information as agreed to by You.

LoanUnbox may share your contact information with its affiliates, staff or third parties with permitted access. However, all such affiliates, staff or third parties, who receive your information, shall be required to observe our confidentiality obligations.

LoanUnbox may engage third-party advertising companies or advertising agencies to advertise on the Website. These companies may utilize information (excepting personal information) about your visits to the Websites and other websites in order to provide advertisements on the Website and other sites about services, facilities and programmers that may be of interest to You.
We may use third-party Service Providers to monitor and analyze the use of our Service.

The Website may contain links to third party websites that are not owned or controlled by LoanUnbox. This Policy does not address how information is handled when provided to any third parties nor the policy of any other affiliate or third party website that may be linked to from the Website.

From time to time, we may change this Privacy Policy. The effective date of this Policy, as stated below, indicates the last time this policy was revised or materially changed. Checking the effective date below allows you to determine whether there have been changes since the last time you reviewed the Policy.

Following are the legal Requirements for the disclosure of data:

Transfer of Data

Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.

If you are located outside India and choose to provide information to us, please note that we transfer the data, including Personal Data, to India and process it there.

Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.

Disclosure of Data

Legal Requirements

LoanUnbox may disclose your Personal Data in the good faith belief that such action is necessary to:

To comply with a legal obligation.

To protect and defend the rights or property of LoanUnbox.

To prevent or investigate possible wrongdoing in connection with the Service.

To protect the personal safety of users of the Service or the public.

To protect against legal liability.

Changes To This Privacy Policy:

We may update our Privacy Policy from time to time. We will notify of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.

                </p>
            </div>
           <SeventhComponent/>
        </div>
    );
};

export default PrivacyPolicy;
